import { render, staticRenderFns } from "./CultivationCard.vue?vue&type=template&id=72782532&scoped=true&"
import script from "./CultivationCard.vue?vue&type=script&lang=js&"
export * from "./CultivationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72782532",
  null
  
)

export default component.exports